import React from 'react';

export const getExpiryStatus = (expiryDate: string | null): 'expired' | 'soon' | null => {
  if (!expiryDate) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const expiry = new Date(expiryDate);
  expiry.setHours(0, 0, 0, 0);
  if (expiry < today) return 'expired';
  const in30 = new Date(today);
  in30.setDate(today.getDate() + 30);
  if (expiry <= in30) return 'soon';
  return null;
};

export const statusStyle = (status: string): React.CSSProperties => {
  const map: Record<string, React.CSSProperties> = {
    Active:    { background: '#dcfce7', color: '#15803d' },
    Empty:     { background: '#fee2e2', color: '#b91c1c' },
    Expired:   { background: '#fef9c3', color: '#854d0e' },
    Discarded: { background: '#f1f5f9', color: '#475569' },
  };
  return map[status] ?? { background: '#f1f5f9', color: '#475569' };
};

/**
 * Floor a consumables total to whole rupees.
 *
 * The client does not collect paise on consumables, so the concession always
 * favours them: 1396.50 is payable as 1396, never 1397. Used by the bill and
 * return entry screens and by the printed invoice so the figure on screen, the
 * figure on the PDF and the figure stored on the bill are the same number —
 * rounding only the printout would leave paise outstanding on every bill.
 *
 * Mirrors _net_total() in backend/app/crud/billing.py, which is what actually
 * gets stored; this keeps the UI honest before the save round-trips.
 */
export const roundDownTotal = (n: number): number =>
  // Settle float error first: 1396.9999… must floor to 1396, not 1395.
  Math.floor(Math.round((Number(n) || 0) * 100) / 100);
